import styled from 'styled-components';

type ImageProps = {
  src: string;
  alt: string;
};

const SectionImage = ({ src, alt }: ImageProps) => {
  return <StyledImage src={src} alt={alt} />;
};


const StyledImage = styled.img`
  width: 100%;
  object-fit: cover;
`;
export default SectionImage;
